export interface GameConfig {
  gameId: string;
  worldChannels: number;
  worldCapacity: number;
  contents: { id: string; name: string; minClearSec: number }[];
  titleTiers: { id: string; maxRank: number; label: string }[];
  founders: { maxNo: number; titleId: string; label: string };
  completion: { titleId: string; label: string };
  dmFriendsOnly: boolean;
  chat: { maxLen: number; minGapMs: number; burst: number; burstWindowMs: number; history: number };
  bannedWords: string[];
  // requireLinked=true면 외부 계정(구글 등)을 연결한 플레이어만 명예의 전당 순번·칭호를 받는다.
  fame?: { requireLinked?: boolean };
  // 보관 정책(일): 채팅 본문(광장·파티·귓속말·보관함) chatDays 뒤 자동 삭제, 신고 기록은 처리 완료 + reportDays, 미처리는 openReportDays 상한.
  retention?: { chatDays?: number; reportDays?: number; openReportDays?: number };
  // 신고 남용 방지: 자동 음소거에 세는 신고자의 최소 활동(채팅·귓속말 개수, 0이면 검사 안 함). 플레이 기록(런·클리어)이 있으면 채팅이 적어도 인정한다.
  moderation?: { reporterMinChats?: number };
  // false면 party:<코드> 채널 가입을 서버가 막는다(멤버십을 검증할 파티 서버가 생기기 전까지 — 코드만 알면 누구나 남의 파티 채널에 들어갈 수 있어서). 기본 true(기존 동작).
  partyChannels?: boolean;
  // 사칭 방지 예약 닉네임에 더할 부분 문자열(기본 목록: 운영자·관리자·GM·admin 등 — shared/filter.ts isReservedName)
  reservedNames?: string[];
}
export interface Title { id: string; label: string }
export interface RunSummary { elapsedMs: number; kills: number; roomsCleared: number; bossDefeated: true; hpLost: number }
export interface PublicMini { id: string; name: string; tag: string; no: number; hero: string | null; title: Title | null; linked: boolean }
export interface Presence { state: 'lobby' | 'battle' | 'party'; where?: string }
export interface Msg {
  id: string;
  channel: string | null;
  kind: 'chat' | 'whisper' | 'system' | 'invite' | 'fame' | 'listing';
  from?: PublicMini;
  to?: string;
  text: string;
  at: number;
  data?: unknown;
}
export interface Session {
  sid: string;
  playerId: string;
  key_hash: string;
  connectedAt: number;
  world: string | null;
  party: string | null;
  presence: Presence;
  presenceAt: number;
  hello: boolean;
  closed?: boolean;
}
export const SOCIAL_PREFIX = '/api/social';
export const DEVICE_KEY = /^[A-Za-z0-9_-]{42}[AEIMQUYcgkosw048]$/;
export const PLAYER_ID = /^p_[a-f0-9]{24}$/;
export const PARTY_CODE = /^[A-F0-9]{20}$/;
export const PARTY_HEROES = ['knight', 'barbarian', 'mage', 'rogue', 'ranger'] as const;
export const NONCE = /^[A-Za-z0-9_-]{8,32}$/;
export const WS_TICKET = /^[a-f0-9]{32}$/;
export const AUTH_PROVIDERS = ['google'] as const;
// free(자유)·inquiry(1:1 문의 — 작성자·관리자만 본다)는 v5에서 추가했다.
export const POST_CATEGORIES = ['bug', 'idea', 'request', 'question', 'free', 'inquiry', 'notice'] as const;
/** 운영 장부(onOps)로 넘기는 고객 글 분류(자유·공지는 제외) */
export const TICKET_CATEGORIES = ['bug', 'idea', 'request', 'question', 'inquiry'] as const;
/** 기본 보관 정책(일). 게임 설정 retention으로 바꾼다 */
export const RETENTION_DEFAULTS = { chatDays: 30, reportDays: 90, openReportDays: 365 };
/** 기본 신고 검증 기준 */
export const MODERATION_DEFAULTS = { reporterMinChats: 20 };
export const POST_STATUSES = ['open', 'reviewing', 'planned', 'done', 'wontfix'] as const;
export const SOCIAL_LIMITS = { bodyBytes: 8192, socketBytes: 2048, runMs: 7200000, listingMs: 600000, ticketMs: 60000 };
